(ns utility-belt.pure
  (:require [clojure.string :as string]
            #?(:clj [clojure.tools.reader.edn :as edn]
               :cljs [cljs.reader :as edn])))

(defn create-keyword
  "Convert the supplied 'named' or 'number' params to strings, concatenate them and return as a keyword"
  [& named]
  (let [str (->> (remove nil? named)
             (map #(cond-> %
                     (or (number? %)
                         (true? %)
                         (false? %)) str
                     true name))
             (apply str))]
    (when-not (string/blank? str)
      (keyword str))))

(defn conj-some
  "conj non-nil values in xs to the collection coll"
  [coll & xs]
  (apply conj coll (remove nil? xs)))

(defn assoc-in-some
  "Like assoc-in but only does the assoc if the value is not nil"
  [m ks v]
  (cond-> m
    (some? v) (assoc-in ks v)))

(defn update-some
  "Like 'update' but returns the map, m, unchanged if the key, k, doesn't exist
   (as opposed to 'update' which creates the key and uses nil as the input to
   the fn)"
  [coll k f & args]
  (if (contains? coll k)
    (apply update coll k f args)
    coll))

(defn update-in-some
  "Like 'update-in' but returns the map, m, unchanged if the key indexed by ks
  doesn't exist (as opposed to 'update' which creates the key and uses nil as
  the input to the fn)"
  [coll ks f & args]
  (if-not (= :not-found (get-in coll ks :not-found))
    (apply update-in coll ks f args)
    coll))

(defn parse-int
  "Parse the supplied string as an integer, returning nil if it's not a valid
  integer. If a string is passed with a decimal place in it only the value to
  the left of the first decimal place will be parsed as an int."
  [string]
  (some->> string
           (string/trim)
           (re-seq #"^(-?\d+).?\d*$")
           (first)
           (second)
           (edn/read-string)))

(defn contains-in?
  "Like 'contains?' but can check for the presence of a key within a nested map"
  [m ks]
  (-> (get-in m (butlast ks))
      (contains? (last ks))))

(defn deep-merge
  "Deep merge the given maps"
  [& maps]
  (if (every? map? (remove nil? maps))
    (apply merge-with deep-merge maps)
    (last maps)))

(defmacro while-let
  "Makes it easy to continue processing an expression as long as it is true

  E.g.: `(while-let [thing (seq (http-get-next-thing))] (do-to-thing thing))`"
  [binding & forms]
  `(loop []
     (when-let ~binding
       ~@forms
       (recur))))
